

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.inventory', ['squid']).factory('$InventoryModel', function ($Model, $Api) {
        return $Model.extend('$InventoryModel', {
            api: new $Api({
                uri: '/api/catalog/:id/item/',
                postAttempts: 2,
                cache: true
            }),

            setInvetoryItems: function setInvetoryItems(inventoryItems) {
                this.inventoryItems = inventoryItems;
            },

            getInventoryItems: function getInventoryItems() {
                return this.inventoryItems;
            }
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-models/src/inventory/index.js
 ** module id = 173
 ** module chunks = 1
 **/